"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pcgDefaultStreamScheme = exports.pcgDefaultOutputFnType = exports.pcgDefaultMultiplier64 = exports.pcgDefaultIncrement64 = void 0;
const long_1 = __importDefault(require("long"));
const types_1 = require("./types");
// export const pcgDefaultIncrement8 = 77
// export const pcgDefaultIncrement16 = 47989
// export const pcgDefaultIncrement32 = Long.fromString('2891336453', 10)
exports.pcgDefaultIncrement64 = long_1.default.fromString('1442695040888963407', 10);
// export const pcgDefaultMultiplier8 = 141
// export const pcgDefaultMultiplier16 = 12829
// export const pcgDefaultMultiplier32 = Long.fromString('747796405')
exports.pcgDefaultMultiplier64 = long_1.default.fromString('6364136223846793005', 10);
exports.pcgDefaultOutputFnType = types_1.OutputFnType.XSH_RR;
exports.pcgDefaultStreamScheme = types_1.StreamScheme.SETSEQ;
